import { DefaultOptionType } from "antd/es/select";
import { ChildEntitiesButton } from "src/common/attrEdit/components";

const buttonNames: Record<ChildEntitiesButton, string> = {
  [ChildEntitiesButton.create]: "Создать",
  [ChildEntitiesButton.assign]: "Выбрать",
};

export const childEntsButtonOptions: DefaultOptionType[] = Object.values(
  ChildEntitiesButton,
).map((button) => ({
  value: button,
  label: buttonNames[button],
}));
